/**
 * Action Types and Outcomes Constants
 * Centralized constants to avoid magic strings throughout the codebase
 */

// Action type codes from database
export const ACTION_TYPES = Object.freeze({
  PROJECT_MAKEN: 'project_maken',
  DEAL_NO_DEAL: 'deal_no_deal',
  OPNIEUW_SOURCEN: 'opnieuw_sourcen',
  KANS_AFWIJZEN: 'kans_afwijzen'
})

// Action outcomes for deal_no_deal type
export const ACTION_OUTCOMES = Object.freeze({
  DEAL: 'deal',
  NO_DEAL: 'no_deal'
})

// Action status values
export const ACTION_STATUS = Object.freeze({
  OPEN: 'open',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
  DELETED: 'deleted'
})

// Deadline presets from database
export const DEADLINE_PRESETS = Object.freeze({
  TUESDAY_12: 'tuesday_12',
  THURSDAY_12: 'thursday_12',
  FRIDAY_17: 'friday_17'
})

// Deadline preset configuration
export const DEADLINE_CONFIG = Object.freeze({
  [DEADLINE_PRESETS.TUESDAY_12]: { day: 2, hour: 12, label: 'Dinsdag 12:00' },
  [DEADLINE_PRESETS.THURSDAY_12]: { day: 4, hour: 12, label: 'Donderdag 12:00' },
  [DEADLINE_PRESETS.FRIDAY_17]: { day: 5, hour: 17, label: 'Vrijdag 17:00' }
})

// Status labels (Dutch)
export const STATUS_LABELS = Object.freeze({
  [ACTION_STATUS.OPEN]: 'Open',
  [ACTION_STATUS.COMPLETED]: 'Afgerond',
  [ACTION_STATUS.CANCELLED]: 'Geannuleerd',
  [ACTION_STATUS.DELETED]: 'Verwijderd'
})

// Action type badge styles
export const ACTION_TYPE_STYLES = Object.freeze({
  [ACTION_TYPES.PROJECT_MAKEN]:
    'bg-green-100 dark:bg-green-900/50 text-green-700 dark:text-green-300',
  [ACTION_TYPES.DEAL_NO_DEAL]:
    'bg-amber-100 dark:bg-amber-900/50 text-amber-700 dark:text-amber-300',
  [ACTION_TYPES.OPNIEUW_SOURCEN]:
    'bg-blue-100 dark:bg-blue-900/50 text-blue-700 dark:text-blue-300',
  [ACTION_TYPES.KANS_AFWIJZEN]: 'bg-red-100 dark:bg-red-900/50 text-red-700 dark:text-red-300'
})

// Status badge styles
export const STATUS_BADGE_STYLES = Object.freeze({
  [ACTION_STATUS.OPEN]: 'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300',
  [ACTION_STATUS.COMPLETED]: 'bg-green-100 dark:bg-green-900/50 text-green-700 dark:text-green-300',
  [ACTION_STATUS.CANCELLED]: 'bg-red-100 dark:bg-red-900/50 text-red-700 dark:text-red-300',
  [ACTION_STATUS.DELETED]: 'bg-red-100 dark:bg-red-900/50 text-red-600 dark:text-red-400'
})

// Helper to check if an action is deal/no deal type
export function isDealNoDealType(action) {
  return action?.action_type_code === ACTION_TYPES.DEAL_NO_DEAL
}

// Helper to get status label
export function getStatusLabel(status) {
  return STATUS_LABELS[status] || status
}

// Helper to get action type badge class
export function getActionTypeBadgeClass(typeCode) {
  return (
    ACTION_TYPE_STYLES[typeCode] || 'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300'
  )
}

// Helper to get status badge class
export function getStatusBadgeClass(status) {
  return (
    STATUS_BADGE_STYLES[status] || 'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300'
  )
}

// Helper to get deadline label
export function getDeadlineLabel(preset) {
  return DEADLINE_CONFIG[preset]?.label || preset
}
